/* eslint-disable import/named */
import { AxiosResponse } from 'axios';
import api from './api';
import {
  Response, Usuario, LoginModel, RetornoLogin, EmailContatoTermoConsentimento,
  LinksUteis,
} from '../pages/models';

export async function LoginAPI(_login: LoginModel):Promise<Response<RetornoLogin>> {
  const response: AxiosResponse<Response<RetornoLogin>> = await api.post('Login', _login);
  const rr = new Response<RetornoLogin>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }

  console.log(response);
  return rr;
};

export async function getUser():Promise<Response<Usuario>> {
  const response: AxiosResponse<Response<Usuario>> = await api.get('Usuario');
  const rr = new Response<Usuario>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function getEmailDPO():Promise<Response<{email: string}>> {
  const response: AxiosResponse<Response<{email: string}>> = await api.get('Usuario/GetEmailDPO');
  const rr = new Response<{email: string}>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function getLinks():Promise<Response<LinksUteis>> {
  const response: AxiosResponse<Response<LinksUteis>> = await api.get('TermoConsentimento/GetLinksLogo');
  const rr = new Response<LinksUteis>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function postUser(User: any):Promise<Response<any>> {
  console.log('passou');
  const response: AxiosResponse<Response<any>> = await api.post('Usuario/AdicionarUsuario', User);
  console.log(response);
  const rr = new Response<any>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function putUser(User: any):Promise<Response<any>> {
  console.log('passou');
  const response: AxiosResponse<Response<any>> = await api.put('Usuario/AlterarUsuario', User);
  console.log(response);
  const rr = new Response<any>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function EsqueceuSenhaAPI(_Email: string):Promise<Response<{mensagem: string}>> {
  const response: AxiosResponse<Response<{mensagem: string}>> = await api.post('Login/EsqueciSenha', { email: _Email });
  const rr = new Response<{mensagem: string}>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  console.log(rr);
  return rr;
};

export async function VerificarEmailExistenteAPI(_Email: string):Promise<Response<boolean>> {
  const response: AxiosResponse<Response<boolean>> = await api.post('Login/VerificarEmailExistente', { email: _Email });
  const rr = new Response<boolean>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  console.log(rr);
  return rr;
};

export async function getEmailTermoConsentimento(
):Promise<Response<EmailContatoTermoConsentimento>> {
  const response: AxiosResponse<Response<EmailContatoTermoConsentimento>> = await api.get('TermoConsentimento/GetEmailContato');
  const rr = new Response<EmailContatoTermoConsentimento>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function postRegstrarEmailConsentimento(
  email:string,
):Promise<Response<boolean>> {
  const response: AxiosResponse<Response<boolean>> = await api.post('TermoConsentimento/RegistrarConsentimento', { email });
  const rr = new Response<boolean>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};
